import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {semanticColor} from "@khanacademy/wonder-blocks-tokens";
import {staticUrl} from "@khan/urls";

import type {Swag} from "./types.ts";

import lockIcon from "@phosphor-icons/core/fill/lock-simple-fill.svg";

const StyledImg = addStyle("img");

interface Props {
    /** Whether the item is "locked" (the user cannot afford the item). */
    isLocked: boolean;
    /** The item to render the thumbnail for */
    item: Swag;
}

/**
 * Renders a thumbnail for a given catalogue item in the Khanmigo Closet.
 */
export const ItemCatalogueThumbnail = (props: Props): React.ReactElement => {
    const {isLocked, item} = props;
    return (
        <View style={styles.thumbnailWrapper}>
            {isLocked && (
                <View style={styles.locked}>
                    <PhosphorIcon
                        color={semanticColor.core.foreground.knockout.default}
                        icon={lockIcon}
                        size="medium"
                    />
                </View>
            )}
            <StyledImg
                alt={item.altText}
                src={staticUrl(`/images/guide/closet-item/${item.id}.svg`)}
                style={styles.thumbnail}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    thumbnailWrapper: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    thumbnail: {
        width: "100%",
        height: "auto",
    },
    locked: {
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        backgroundColor: semanticColor.core.background.disabled.strong,
    },
});
